<template>
    <div class="form-group">
        <label v-if="label">{{ label }}</label>
        <br v-if="label">

        <div class="form-check-inline" v-for="item in items" :key="item.value">
            <input :id="name + '-' + item.value" class="form-check-input" type="radio" :name="name" :value="item.value" :checked="value === item.value" @change="$emit('input', item.value)"/>
            <label :for="name + '-' + item.value" class="form-check-label">
                {{ item.label }}
            </label>
        </div>

        <div class="invalid-feedback d-block" v-if="error">
            {{ error }}
        </div>
    </div>
</template>

<script>
export default {
    name: "RadioInput",
    props: {
        name: { type: String, required: true },
        label: { type: String, default: '', required: false },
        items: { type: Array, required: true },
        value: { type: String|Number, required: true },
        error: { type: String, default: '', required: false },
    },
}
</script>